export const Input = ({ name, value, dispatch }) => {
    return(
        <label className="textInput">
            <span>{name}</span>
            <input type="text" onChange={(e) => { e.preventDefault(); dispatch({ type: "change", name, value: e.target.value })}} value={value} name={name}/>
        </label>
    )
}